// extracted by mini-css-extract-plugin
export var cardIcon = "_51-4";
export var checkboxCard = "_51-0";
export var checkboxCardSelected = "_51-3";
export var disabled = "_51-1";
export var outerBorder = "_51-2";
export var spacerMedium = "_51-7";
export var spacerSmall = "_51-6";
export var spacerXsmall = "_51-5";